// extracted by mini-css-extract-plugin
export default {"topText":"HnxqM9lVfQLbj_lbZdyx"};